import React from "react";

import {Authorizations, hasAuthorization} from "../../utils/authorizations";
import {sessionStore} from "../../utils/sessionStore";
import {Route} from "react-router-dom";
import WMS from "views/wms";
import RequireWmsAuthentication from "../../hoc/authentication/requireWmsAuthentication";

let routes  = [];

const applications = sessionStore.get("applications");
const authorizations = sessionStore.get("authorizations") ?? [];

if (applications && applications["wms"]) {
    if (hasAuthorization(authorizations, Authorizations.WMS_ACCESS)) {
        routes.push([
            <Route
                path="/wms"
                component={RequireWmsAuthentication(WMS)}
                key="wms"
            />,
        ])
    }
}

export default routes;
